export default __webpack_public_path__ + "static/media/480_store05-fr-web.69c6bfe9.png";